<!-- Header -->
<mat-card class="no-overflow margin all custom-card">
  <mat-card-header class="add-competitor-header">
    <mat-card-title>LFIC Competitor Pinning</mat-card-title>
    <button mat-icon-button (click)="close()"><mat-icon>close</mat-icon></button>
  </mat-card-header>

  <!-- Content -->

  <mat-card-content >
    <form [formGroup]="addPinningForm" autocompete="off" (keyup.enter)="addPinning()" class="margin all">
      <!-- Reason -->
      <div class="padding all full-width">
            <label
              for="pinning"
              [ngClass]="{
                'error-message': fieldHasError(addPinningForm, 'pinning'),
                focus: focus.pinning
              }"
            >
              What type of LFIC competitor pinning should be applied to the cylinder(s)?
            </label>
        <mat-form-field appearance="outline" floatLabel="always" class="full-width">
          <mat-select
            [ngClass]="{
              error: fieldHasError(addPinningForm, 'pinning'),
              'focus-border': focus.pinning
            }"
            (focus)="focusOn('pinning')"
            (focusout)="focusOn('pinning')"
            matNativeControl
            formControlName="pinning"
            [(value)]="selectedpinning"
          >
            <mat-option *ngFor="let pinning of pinningLFIC" [value]="pinning.value"> {{ pinning.name }} </mat-option>
          </mat-select>
          <!-- Errors -->
          <div *ngFor="let validation of errorMessages.pinning">
            <div
              class="caption error-message"
              *ngIf="fieldHasErrorMessages(addPinningForm, validation, 'pinning')"
              id="pinningErrors"
            >
              {{ validation.message }}
            </div>
          </div>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>

  <!-- Buttons -->
  <mat-card-actions>
    <div class="row flex-end">
      <button mat-raised-button id="cancel" (click)="close()">Cancel</button>
      <button
        type="submit"
        mat-raised-button
        (click)="addPinning()"
        class="margin left"
        [disabled]="!addPinningForm.valid"
        id="create"
      >
        Add Pinning
      </button>
    </div>
  </mat-card-actions>
</mat-card>
